export const createAuthorizationFailureLifecycle = () => {
  let currentHandlers = null;

  const update = ({ logout, navigate } = {}) => {
    currentHandlers = {
      logout: typeof logout === 'function' ? logout : null,
      navigate: typeof navigate === 'function' ? navigate : null,
    };
  };

  const clear = () => {
    currentHandlers = null;
  };

  const handle = ({ status } = {}) => {
    if ((status !== 401 && status !== 403) || !currentHandlers) return false;
    const logout = currentHandlers.logout;
    let logoutResult;
    try {
      logoutResult = logout?.();
    } catch (_) {
      logoutResult = undefined;
    }
    Promise.resolve(logoutResult)
      .catch(() => {})
      .then(() => currentHandlers?.navigate?.('/login', { replace: true }));
    return true;
  };

  return { update, clear, handle };
};
